<template>
    <div>
        <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
            <Form-item label="密码" prop="password">
                <Input type="password" v-model="formCustom.password"></Input>
            </Form-item>
            <Form-item label="确认密码" prop="passwdCheck">
                <Input type="password" v-model="formCustom.passwdCheck"></Input>
            </Form-item>
            <Form-item>
                <Button type="primary" @click="handleSubmit('formCustom')">提交</Button>
                <Button type="ghost" @click="handleReset('formCustom')" style="margin-left: 8px">重置</Button>
            </Form-item>
        </Form>
        <el-dialog title="提交" :visible.sync="addShow">
            <p>确认要提交？</p>
            <div slot="footer" class="dialog-footer">
                <Button @click="addShow=false">取 消</Button>
                <Button type="primary" @click="axiosFn">确 定</Button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data () {
            const validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if(!/^[a-zA-Z0-9]{6,12}$/.test(value)){
                        callback(new Error('账户名格式不对，请输入6-12位英文或数字'));
                    }else{
                        if (this.formCustom.passwdCheck !== '') {
                            // 对第二个密码框单独验证
                            this.$refs.formCustom.validateField('passwdCheck');

                            callback();
                        }
                    }
                }
            };
            const validatePassCheck = (rule, value, callback) => {
                if (value == '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.formCustom.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                formCustom: {
                    password: '',
                    passwdCheck: '',
                },
                addShow:false,
                ruleCustom: {
                    password: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    passwdCheck: [
                        { validator: validatePassCheck, trigger: 'blur' }
                    ],
                }
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
        },
        methods: {
            handleSubmit (name) {
                var _this=this;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.addShow=true;
                    } else {
                        this.$Message.error('表单验证失败!');
                    }
                })
            },
            axiosFn(){
                this.addShow=false;
                var _this=this;
                _this.$http.get('/web/user/updatePassword',{
                    params:{
                        uid:_this.$route.query.uid,
                        password:_this.formCustom.password,
                    }
                }).then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title: '修改密码',
                            desc: res.message,
                        });
                        _this.$router.push({path:'/Right'});
                    }else{
                        _this.$Notice.error({
                            title: '修改密码',
                            desc: res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title: '修改密码',
                        desc: '修改密码成功',
                    });
                });
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/rightsApp/passRight.vue